import { KategoriaAktEuApi, KategoriaEnum } from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new KategoriaAktEuApi(apiConfiguration(elegislativaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const changeKategoria = async (
  type: string,
  year: number,
  index: number,
  kategoria: KategoriaEnum,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.setKategoria(type, year, index, { kategoria }, headers);
  return { responseCode: status };
};
